import { Alert, ErrorSummary, Paragraph } from "@digdir/designsystemet-react";
import type { FieldError, FieldErrors, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

type BestillingFormErrorSummaryProps<TFieldValues extends FieldValues> = {
  errors?: FieldErrors<TFieldValues>;
};
export const BestillingFormErrorSummary = ({
  errors,
}: BestillingFormErrorSummaryProps<FieldValues>) => {
  const { t } = useTranslation();
  const errorArray = errors ? Object.keys(errors) : [];
  if (errorArray.length === 0) return null;
  return (
    <ErrorSummary className="space-y-4 border border-balder-border-danger-strong">
      <ErrorSummary.Heading>
        {t("skjema.feil-oppsummering")}
      </ErrorSummary.Heading>
      <ErrorSummary.List>
        {errorArray.map((key) => {
          const error = errors?.[key] as FieldError | undefined;
          if (!error?.message) return null;
          return (
            <ErrorSummary.Item key={`error-${error.message}`}>
              <ErrorSummary.Link href={`#${key}`}>
                {t(error.message, { context: error.type })}
              </ErrorSummary.Link>
            </ErrorSummary.Item>
          );
        })}
      </ErrorSummary.List>
    </ErrorSummary>
  );
};

export const BestillingFormError = ({
  errors = [],
}: {
  errors: FieldError | FieldError[] | undefined;
}) => {
  const { t } = useTranslation();
  if (!errors) return null;
  const errorArray = Array.isArray(errors) ? errors : [errors];
  if (errorArray.length === 0) return null;
  return (
    <Alert data-color="danger" className="space-y-4">
      {errorArray.map((error) => {
        if (!error?.message) return null;
        return (
          <Paragraph key={`error-${error.message}`}>
            {t(error.message)}
          </Paragraph>
        );
      })}
    </Alert>
  );
};
